import {API_USER_LIST, API_GET_USER_WORK_PLANT_ENTRY, API_ADD_USER_FIRST_PAGE_CONFIG, API_GET_USER_FIRST_PAGE_CONFIG, API_UPDATE_WORK_PLANT_ENTRY, API_USER_DELETE, API_USER_DETAIL, API_USER_CHECKUSERIFEXIST, API_USER_CHANGE_STATE, API_USER_SAVE, API_USER_UPD_PWD, API_USER_CHECKUSERIFEXIST_FOR_MY_BASEINFO_EDIT, API_DRAG_WORK_PLANT_ENTRY, API_NEW_TENANT_ADD_BY_CS} from '@/common/constants';
import { get, post, del } from '@/utils/http';

const pendingUserListMap = new Map();

const getUserListPendingKey = (params) => {
    let sortedParams = {};
    Object.keys(params).sort().forEach((key) => {
        sortedParams[key] = params[key];
    });
    return JSON.stringify(sortedParams);
};

const clearUserListPending = (pendingKey, requestPromise) => {
    if (pendingUserListMap.get(pendingKey) === requestPromise) {
        pendingUserListMap.delete(pendingKey);
    }
};

export const getUserList = (params = {}) => {
    let requestParams = Object.assign({}, {
        currentPage: 1,
        pageSize: 1000
    }, params);
    let pendingKey = getUserListPendingKey(requestParams);
    let requestPromise = pendingUserListMap.get(pendingKey);
    if (!requestPromise) {
        requestPromise = get(API_USER_LIST, requestParams);
        pendingUserListMap.set(pendingKey, requestPromise);
    }
    return requestPromise.then((res) => {
        clearUserListPending(pendingKey, requestPromise);
        return res;
    }, (error) => {
        clearUserListPending(pendingKey, requestPromise);
        return Promise.reject(error);
    });
};

export const getUserDetail = (userId) => {
    return get(API_USER_DETAIL.replace(':userId', userId));
};

export const checkUserIfexist = (input, userid) => {
    return get(API_USER_CHECKUSERIFEXIST.replace(':input', input), {userid: userid});
};

export const checkUserIfexistForEdit = (input) => {
    return get(API_USER_CHECKUSERIFEXIST_FOR_MY_BASEINFO_EDIT.replace(':input', input));
};

export const delUser = (userId) => {
    return del(API_USER_DELETE.replace(':userId', userId));
};

export const changeUserState = (userId, userState) => {
    return post(API_USER_CHANGE_STATE, { userId, userState });
};

export const saveUser = (user) => {
    return post(API_USER_SAVE, user);
};

export const updUserPwd = (user) => {
    return post(API_USER_UPD_PWD, user);
};
export const getUserWorkPlantEntry = (params) => {
    return get(API_GET_USER_WORK_PLANT_ENTRY, params);
};
export const getUserFirstPageConfig = (params) => {
    return get(API_GET_USER_FIRST_PAGE_CONFIG, params);
};
export const addUserFirstPageConfig = (params) => {
    return get(API_ADD_USER_FIRST_PAGE_CONFIG, params);
};
export const updateWorkPlantEntry = (param) => {
    return post(API_UPDATE_WORK_PLANT_ENTRY, param);
};

export const dragWorkPlantEntry = (param) => {
    return post(API_DRAG_WORK_PLANT_ENTRY, param);
};

// 客服直接新增个企业
export const addNewTenantByCs = (params) => {
    return post(API_NEW_TENANT_ADD_BY_CS, params);
};



// WEBPACK FOOTER //
// ./src/data-model/system/user-model.js